const PERMISSION_KEY= "crm:wall_of_love";
const PAGE_URL = {
    WALL_OF_LOVE_PAGE: "/admin/crm/wall-of-love"
}

export {PERMISSION_KEY, PAGE_URL}

